import { ReactComponent as Delete } from "../../../../assets/images/remove.svg";
import AcedTooltip from "../../tooltip/AcedTooltip";

import "./DeleteButton.scss";
export interface DeleteButtonProps {
  onClick: any;
  tooltip?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onClick,
  tooltip,
}) => {
  const main = () => {
    return (
      <div onClick={onClick} className="delete-button">
        <Delete className="delete-icon" />
      </div>
    );
  };
  return (
    <>
      {tooltip ? (
        <AcedTooltip text={tooltip}>{main()}</AcedTooltip>
      ) : (
        <>{main()}</>
      )}
    </>
  );
};

export default DeleteButton;
